import React from "react";
import { GlobalContext } from "../../../../../utils/globalprovider";
import ToolsBar from "../../../../../components/bases/toolsbar/toolsbar";


import SubtitleSelectionMode from "./SubtitleRange/subtitleselectionmode";


import imgexit from "./assets/exit.png"
import imgaccept from "./assets/accept.png"

import "./submenus.css"


class DeleteSubtitles extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.state =
        {
            toolsbar : {
                height: 26,
                items: [
                    {img: imgexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                    {type:"space"},
                    {img: imgaccept ,type:"button", disable:false,fr:"Lancer",en:"Start", nochangecolor:false, key:{key:"START", cat:"actions"}},


                    ],
            },

        }



        this.selectionModeRef = React.createRef();
        this.onClickToolsBar = this.onClickToolsBar.bind(this);
    }




    onClickToolsBar(datas)
    {
        switch (datas.key)
        {
            case "START":
                if (this.props.onaction) 
                {
                    const ret = {
                        source: "parameters",
                        action:
                        {
                            
                            type: "delete",
                            parameters: {},
                            range: this.selectionModeRef.current.getValues(),
                        }
                    };

                    console.log("retour", ret);
                    if (this.props.onaction) this.props.onaction (ret);
                }

                
                break;


            case "EXIT":
                if (this.props.onaction) this.props.onaction ({source:"submenu", submenu: {key:"EXIT"}});
                break;
        }
    }


    render()
    {
        const title = this.context.language=="fr"?"Suppression de sous-titres":"Delete subtitles range";
                return (
                    <div className="submenuMain">
                            <div className="submenuTitle">{title}</div>

                            <div className="submenuCurrentDiv">
                                <SubtitleSelectionMode ref = {this.selectionModeRef}
                                    value="current"
                                    onChange={(value) => console.log(value)}
                                    lineonly = {false}
                                    subtitles = {this.props.subtitles} 
                                    current = {this.props.current}
                                />                                
                            </div>
                            <div className="submenuBottom">
                            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} background={false}/>
                        </div>
                    
                    </div>
                )

    }

}

DeleteSubtitles.defaultProps = 
{
}

export default DeleteSubtitles;



